<ng-template #nodeTemplate let-nodeList>
  <ul class="ui-tree__list">
    @for (node of nodeList; track node.label + $index) {
      <li class="ui-tree__item">
        <span class="ui-tree__row">
          @if (node.children?.length) {
            <span class="ui-tree__arrow" aria-hidden="true">
              <ui-icon name="chevron-down" size="sm" />
            </span>
          } @else {
            <span class="ui-tree__bullet" aria-hidden="true"></span>
          }
          <span class="ui-tree__label">{{ node.label }}</span>
        </span>
        @if (node.children?.length) {
          <ng-container
            *ngTemplateOutlet="nodeTemplate; context: { $implicit: node.children }"
          />
        }
      </li>
    }
  </ul>
</ng-template>

<div class="ui-tree" role="tree">
  <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: nodes() }" />
</div>
